import { useContext } from 'react';

import { EditorOpenedPanelsContext } from '../../components/editor-integration/opened-panels/EditorOpenedPanelsContext';

export const useOpenedPanels = () => useContext(EditorOpenedPanelsContext);
